import React, { Component } from 'react';
import ReactSlider from 'react-slider';
import FormField from '../../components/FormField';
import Typography from '@material-ui/core/Typography';
import i18n from 'i18n/i18n';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { showModal } from 'redux/modules/modal';
import classNames from 'classnames';
import { CheckIconRounded, SpinnerIcon, UpdateSeatsIcon } from '../../theme/icons';
import { 
	Link,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	Button,
	Grid,
	Tooltip,
	IconButton,
	withStyles,
	ClickAwayListener
} from '@material-ui/core';
import MuiExpansionPanel from '@material-ui/core/ExpansionPanel';
import MuiExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import MuiExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import PropTypes from 'prop-types';
import {
	SUBSCRIPTION_PLAN,
	SUBSCRIPTION_PERIOD,
	PACKAGES_CONFIG,
	PACKAGES_HIDE_SIDEBAR_BREAKPOINT,
	CB_API_FETCH_CURRENCY,
	FORCE_RE_CHECKOUT_WITH_ALL_USERS
} from '../../config';
import { openIntercomChat } from 'utils/intercom';
import _ from 'lodash';
import { setSeatsQuantity } from 'redux/modules/app';
import { trackQuantityChange } from 'lib/Segment/customTrackers';
import { getTrackingOptions } from 'lib/Segment/helpers';
import { Info } from '../../theme/icons';
import ERRORS from '../../errors/errorids';

const localize = i18n.loc.localize;

const errors = {
	[ERRORS.OFFLINE] : localize('subscriptions-error-offline'),
	[ERRORS.API_REQUEST_LIMIT_EXCEEDED] : localize('error-cb-api-rate-limit-reached')
};

const ExpansionPanel = withStyles({
	root: {
		boxShadow: 'none',
		borderBottom: '2px solid #F2F2F2',
		marginTop: '10px',
		borderRadius: 0,
		'&:before': {
			display: 'none',
		},
	},
	expanded: {
		margin: '10px auto 0',
	},
})(MuiExpansionPanel);

const ExpansionPanelSummary = withStyles({
	root: {
		background: 'none',
		borderBottom: 'none',
		marginBottom: 0,
		minHeight: 56,
		padding: 0,
		'&$expanded': {
			minHeight: 56,
		},
		'& [class*=expandIcon]': {
			top: '22%',
			right: 0,
			padding: 0
		},

	},
	content: {
		margin: '0',
		'&$expanded': {
			margin: '0'
		},
	},	
	expanded: {},
})(props => <MuiExpansionPanelSummary {...props} />);
ExpansionPanelSummary.muiName = 'ExpansionPanelSummary';

const ExpansionPanelDetails = withStyles(theme => ({
	root: {
		padding: '0 0 12px'
	},
}))(MuiExpansionPanelDetails);

const styles = theme => ({
	realEstateUiWrapper: {
		maxWidth: '1600px'
	},
	/* slider header */
	sliderHeader: {
		flexDirection: 'column',
		textAlign: 'center',
		marginBottom: 30
	},
	sliderTitle: {
		color: '#2A3F51',
		fontSize: '20px',
		lineHeight: '24px',
		marginBottom: 19,
		display: 'block',
		opacity: 1,
		fontFamily: 'Poppins, sans-serif',
		fontWeight: 600,
	},
	sliderSubtitle: {
		fontSize: '20px',
		lineHeight: '24px',
		fontFamily: 'Roboto, sans-serif',
		fontWeight: 300,
		display: 'block',
		color: '#16212A',
		opacity: 1
	},
	
	/* slider */
	sliderWrapper: {
		margin: '0 auto 62px',
		maxWidth: 1050,
		'&.hasCurrency': {
			maxWidth: 1225,
		},
		'&.reducedMargin': {
			marginBottom: '37px'
		},
		'@media screen and (max-width: 1200px)': {
			display: 'block',
			textAlign: 'center'
		},
	},
	sliderGrid: {
		'&.hasCurrency': {
			maxWidth: 698
		},		
		flex: '1 1 calc(100% - 230px - 25px)',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		position: 'relative',
		'@media screen and (max-width: 1200px)': {
			margin: '0 auto',
			maxWidth: 698
		},
	},
	sliderValueWrapper: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		flex: '0 0 230px',
		marginLeft: 20,
		color: '#2A3F51',
		'@media screen and (max-width: 1200px)': {
			margin: '20px auto'
		}		
	},

	agentsLegendLabel: {
		fontFamily: 'Poppins, sans-serif',
		fontWeight: 300,
		fontSize: i18n.getCurrentLanguage(false) === 'de' ? '17px' : '20px',
		lineHeight: '24px',
		opacity: 1
	},
	agentsLegendValue: {
		fontWeight: 600,
		color: '#002748',
		marginLeft: 5,
		cursor: 'pointer'
	},
	quantityNumberInfo: {
		opacity: 1
	},
	quantityNumberInfoClickToEdit: {
		paddingTop: 6
	},
	quantityNumberInfoSave: {
	},
	agentsQuantityField: {
		margin: '-6px 0 0 7px',
		width: '60px',

		'& input': {
			height: '20px',
			borderWidth: 1,
			borderStyle: 'solid',
			borderRadius: 5,
			borderColor: '#2a3f51',
			padding: '7px 10px',
			color: '#333',
			fontWeight: 600,
			fontSize: '18px',
			lineHeight: '20px',

			'&:focus': {
				borderColor: theme.palette.primary.main
			},

			'&::placeholder': {
				fontFamily: 'Open Sans, sans-serif',
				fontWeight: 'normal',
				fontStyle: 'normal',
				fontSize: '14px',
				lineHeight: '19px',
				color: theme.palette.text.primary
			}
		}
	},

	currencySelectorGrid: {
		flex: '0 0 160px',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		marginLeft: 20,
		'& > *': {
			marginBottom: '0 !important'
		},
		'@media screen and (max-width: 1200px)': {
			margin: '0 auto',
			maxWidth: '160px'
		},
	},
	slider: {
		background: '#EDEEEF',
		borderRadius: 12,
		height: 12,

		'& .bar-0': {
			height: 12,
			borderRadius: 12,
			backgroundImage: 'linear-gradient(90deg, #0ab5ff, #0ab5ff 50%, #0065f0)'
		},
		
		'&.disabled': {
			opacity: 0.5
		}		
	},
	handle: {
		width: '20px',
		height: '20px',
		backgroundColor: '#fff',
		boxShadow: '0px 3px 6px rgba(214, 214, 214, 1);',
		borderRadius: '50%',
		marginTop: '-5px',
		cursor: 'pointer'
	},

	/* packages */
	packagesContainerWrapper: {
		display: 'flex',
		justifyContent: 'space-between',
		flexFlow: 'row nowrap',
		'@media screen and (max-width: 770px)': {
			flexDirection: 'column'
		}
	},
	package: {
		flex: '0 0 calc(50% - 12px)',
		padding: '32px',
		background: '#fff',
		borderRadius: 30,
		border: '1px solid #fff',
		transition: 'all .3s ease-in-out',
		position: 'relative'
	},


	/* package elements */
	packageTag: {
		opacity: 1,
		display: 'inline-block',
		padding: '2px 9px',
		borderRadius: '3px',
		fontFamily: 'Poppins, sans-serif',
		fontWeight: 500,
		fontSize: '15px',
		lineHeight: '18px',
		marginBottom: '21px',
		textTransform: 'uppercase',
		letterSpacing: '0.5px'
	},
	packageTitle: {
		fontSize: '35px',
		lineHeight: '39px',
		color: '#002748',
		fontFamily: 'Poppins, sans-serif',
		fontWeight: 600,
		marginBottom: '10px'
	},
	packagePrice: {
		opacity: 1,
		fontSize: '40px',
		lineHeight: '44px',
		color: '#002748',
		fontFamily: 'Poppins, sans-serif',
		fontWeight: 600,
		marginBottom: '22px',
		'& span': {
			color: '#2A3F51',
			fontWeight: 300,
			fontSize: '15px',
			lineHeight: '19px'
		}
	},
	packageSubtitle: {
		opacity: 1,
		color: '#2A3F51',
		fontFamily: 'Poppins, sans-serif',
		fontWeight: 300,
		fontSize: '15px',
		lineHeight: '19px',
		marginBottom: '34px'
	},
	packageEndsOn: {
		fontSize: '18px',
		lineHeight: '20px',
		fontFamily: 'Roboto, sans-serif',
		color: '#D30404',
		position: 'absolute',
		top: '35px',
		right: '40px'
	},

	/* features list */
	featuresGroupTitle: {
		fontSize: '15px',
		lineHeight: '19px',
		color: '#002748',
		fontFamily: 'Poppins, sans-serif',
		fontWeight: 600,
		paddingTop: '32px',
		marginBottom: '12px'
	},
	featuresList: {
		listStyle: 'none'
	},
	featuresListItem: {
		'&:not(:first-child)': {
			marginTop: '8px'
		},
		padding: '2px 0',
		alignItems: 'start',
	},
	featuresListIcon: {
		color: '#0065f0',
		padding: 0,
		margin: '-2px 0 0'
	},
	featuresListTitle: {
		opacity: 1,
		fontSize: '15px',
		lineHeight: '19px',
		fontFamily: 'Roboto, sans-serif',
		fontWeight: 400,
		color: '#2A3F51'
	},
	featuresListDescription: {
		opacity: 1,
		display: 'block',
		fontSize: '13px',
		lineHeight: '17px',
		color: '#808082',
		fontFamily: 'Roboto, sans-serif',
		fontWeight: 300,
		paddingTop: '7px'
	},

	/* sections list */
	sectionsListIcon: {
		color: '#002748',
		fontSize: '30px'
	},
	sectionsListTitle: {
		fontSize: '15px',
		lineHeight: '19px',
		color: '#002748',
		fontFamily: 'Poppins, sans-serif',
		fontWeight: 600,
		padding: '0 30px 0 0',
		position: 'relative',
	},
	sectionsListDescription: {
		opacity: 1,
		fontSize: '13px',
		lineHeight: '17px',
		fontFamily: 'Roboto, sans-serif',
		fontWeight: 300,
		color: '#808082',
		paddingTop: '7px',
		paddingBottom: '10px'
	},

	/* styles for individual packages */
	individualAgentsPackage: {
		'& .packageTag': {
			background: '#E1E8FF',
			color: '#0065F0'
		}
	},

	brokeragesPackage: {
		boxShadow: '15px 15px 50px rgba(0, 101, 240, 0.2)',
		'& .packageTag': {
			background: '#0065F0',
			color: '#fff'
		},
		'& .packagePrice': {
			color: '#0065F0',
			marginBottom: 0
		}
	},

	singleAgentCurrentPlan: {
		'& .individualAgentsPackage': {
			border: '1px solid #ddd',
			opacity: '0.5'
		},
		'& .brokeragesPackage': {
			border: '1px solid #0065F0'
		}		
	},

	brokeragesCurrentPlan: {
		'& .individualAgentsPackage': {
			opacity: '0.5',
			boxShadow: '15px 15px 50px rgba(0, 101, 240, 0.2)',
			'@media screen and (max-width: 770px)': {
				order: 2,
			}
		},
		'& .brokeragesPackage': {
			border: '1px solid #0065F0',
			'@media screen and (max-width: 770px)': {
				order: 1,
			}
		}
	},

	brokeragesPlanPendingCancellation: {
		'& .individualAgentsPackage': {
			border: '1px solid #ddd',
			opacity: '0.5'
		},
		'& .brokeragesPackage': {
			border: '1px solid #0065F0',
			boxShadow: '15px 15px 50px rgba(0, 101, 240, 0.2)',
			opacity: 1
		}				
	},

	singleAgentPlanPendingCancellation: {
		'& .individualAgentsPackage': {
			border: '1px solid #0065F0',
			boxShadow: '15px 15px 50px rgba(0, 101, 240, 0.2)',
		},		
		'& .brokeragesPackage': {
			border: '1px solid #ddd',
			opacity: '0.5',
			boxShadow: 'none'
		}
	},

	brokeragesPlanCancelled: {
		'& .brokeragesPackage': {
		},		
	},

	singleAgentPlanCancelled: {
		'& .individualAgentsPackage': {
			border: '1px solid #ddd',
		}		
	},

	singleAgentCardActive: {
		'& .individualAgentsPackage': {
			border: '1px solid #0065F0',
			opacity: '1',
			'@media screen and (max-width: 770px)': {
				order: 1,
				marginBottom: '20px',
			}
		},
		'& .brokeragesPackage': {
			opacity: '0.5',
			'@media screen and (max-width: 770px)': {
				order: 2,
			}
		}
	},
	brokeragesCardActive: {
		'& .individualAgentsPackage': {
			opacity: '0.5',
			'@media screen and (max-width: 770px)': {
				order: 2,
			}
		},
		'& .brokeragesPackage': {
			border: '1px solid #0065F0',
			opacity: '1',
			'@media screen and (max-width: 770px)': {
				order: 1,
				marginBottom: '20px',
			}
		}		
	},

	brokerageDecreasingSeats: {
		'& .individualAgentsPackage': {
			opacity: '1',
		},
		'& .brokeragesPackage': {
			opacity: '1',
			'& > *': {
				opacity: 0.5
			},
			'& .packageTag': {
				opacity: 1
			},
			'& .packageTitle': {
				opacity: 1
			},
			'& .packagePrice': {
				opacity: 1
			},
			'& .packageSubtitle': {
				opacity: 1
			}
		}
	},

	brokerageIncreasingSeats: {
		'& .individualAgentsPackage': {
			opacity: '0.5',
		},
		'& .brokeragesPackage': {
			opacity: '1',
		}		
	},

	singleAgentPlanDisabled: {
		'& .individualAgentsPackage': {
			opacity: '0.5',
		},
	},

	// buttons
	purchaseButtonContainer: {
		paddingTop: 30
	},

	button: {
		borderRadius: '6px',
		display: 'inline-block',
		minWidth: '255px', 
		fontFamily: 'Poppins, sans-serif',
		padding: '11px 20px',
		textAlign: 'center',
		textTransform: 'uppercase',
		whiteSpace: 'nowrap',
		textShadow: 'none',
		transition: 'all .3s ease-in-out',

		'&.disabled': {
			color: theme.palette.colors.colorWithAlpha(theme.palette.common.black, 0.60),
			background: theme.palette.colors.colorWithAlpha(theme.palette.common.black, 0.15),
			border: 0
		}
	},

	purchaseButtonContained: {
		backgroundImage: 'linear-gradient(90deg,#0ab5ff,#0ab5ff 50%,#0065f0)',
		backgroundPosition: '100% 50%',
		backgroundRepeat: 'no-repeat',
		backgroundSize: '200% 100%',
		padding: '13px 20px',
		'&:hover': {
			backgroundPosition: '0 50%'
		},
		'&.updating': {
			color: '#fff'
		}
	},

	purchaseButtonOutlined: {
		border: '2px solid #0065f0',
		color: '#0065f0',
		'&:hover': {
			background: '#0065f0',
			color: '#fff',
			opacity: 1
		}
	},

	/* subscription status and links */
	statusAndLinksGrid: {
		width: '100%',
		marginTop: '40px',
		paddingTop: '44px',
		borderTop: '2px solid #f3f3f3',
		'@media screen and (max-width: 770px)': {
			flexDirection: 'column',
		}

	},
	statusGrid: {
		paddingLeft: '30px',
		width: '50%',
		'@media screen and (max-width: 770px)': {
			width: '100%',
			padding: 0,
			textAlign: 'center'
		}
	},
	nextBilling: {
		opacity: 1,
		fontFamily: 'Roboto, sans-serif',
		fontSize: '18px',
		lineHeight: '21px',
		'& strong': {
			color: '#5C5D5D',
			fontFamily: 'Poppins, sans-serif',
			fontWeight: 600,
		},
	},
	status: {
		marginTop: '12px',
		opacity: 1,
		fontFamily: 'Roboto, sans-serif',
		fontSize: '18px',
		lineHeight: '21px',
		'& strong': {
			color: '#5C5D5D',
			fontFamily: 'Poppins, sans-serif',
			fontWeight: 600,
		},
	},
	statusActive: {
		color: '#00AA55'
	},
	statusCancelled: {
		color: '#D30404'
	},
	linksGrid: {
		paddingRight: '30px',
		width: '50%',
		'@media screen and (max-width: 770px)': {
			width: '100%',
			padding: 0,
			textAlign: 'center'
		}
	},
	manageCBList: {
		display: 'flex',
		flexFlow: 'row nowrap',
		justifyContent: 'right',
		'@media screen and (max-width: 770px)': {
			display: 'block',
			textAlign: 'center'
		}
	},
	manageCBListItem: {
		width: 'auto',
		'@media screen and (max-width: 770px)': {
			display: 'block',
			width: '100%',
			textAlign: 'center'
		}		
	},
	manageCBLink: {
		opacity: 1,
		fontFamily: 'Roboto, sans-serif',
		fontSize: '18px',
		lineHeight: '21px',
		color: '#5C5D5D',
	},

	/* info tooltip */
	infoIconButton: {
		position: 'relative',
		top: '-2px',
		width: 16,
		height: 16,
		marginRight: 6,
		color: theme.palette.colors.white,
		backgroundColor: '#d30404',
		borderColor: '#d30404',
		padding: 0,
		'&:hover': {
			backgroundColor: `${theme.palette.colors.black}`,
			borderColor: `${theme.palette.colors.black}`
		}
	},

	tooltipArrow: {
		position: 'absolute',
		fontSize: 6,
		width: '3em',
		height: '1em',
		top: 0,
		left: '50%',
		transform: 'translateX(-50%)',
		marginTop: '-0.95em',
		'&::before': {
			content: '""',
			margin: 'auto',
			display: 'block',
			width: 0,
			height: 0,
			borderStyle: 'solid',
			borderWidth: '0 1em 1em 1em',
			borderColor: `transparent transparent ${theme.palette.common.black} transparent`,
		}
	},
	infoTooltip: {
		padding: 7,
		backgroundColor: theme.palette.common.black
	},
	infoTooltipText: {
		color: theme.palette.common.white,
		opacity: 1,
		pointerEvents: 'auto'
	},

	addMoreSeatsWrapper: {
		flexDirection: 'column'
	},

	addMoreSeatsGrid: {
		textAlign: 'center'
	},

	addMoreSeatsMesssage: {
		margin: '0 auto 35px',
		opacity: 1,
		display: 'block',
		fontSize: '15px',
		lineHeight: '19px',
		color: '#808082',
		fontFamily: 'Roboto, sans-serif',
		fontWeight: 300,
		paddingTop: '7px',
	},

	updateSeatsButton: {
		display: 'flex',
		margin: '0 auto 12px',
		backgroundImage: 'linear-gradient(90deg,#0ab5ff,#0ab5ff 50%,#0065f0)',
		backgroundPosition: '100% 50%',
		backgroundRepeat: 'no-repeat',
		backgroundSize: '200% 100%',
		padding: '13px 20px',
		color: '#fff',
		transition: 'all .3s ease-in-out',
		'&:hover': {
			backgroundPosition: '0 50%'
		}
	},

	updateSeatsButtonIcon: {
		marginRight: '7px'
	},

	/* error message */
	successMessage:  {
		margin: '-20px auto 35px',
		opacity: 1,
		display: 'block',
		fontSize: '15px',
		lineHeight: '19px',
		fontFamily: 'Roboto, sans-serif',
		textAlign: 'center',
		fontWeight: 300,
		paddingTop: '7px',
		color: '#2A3F51',
	},

	/* error message */
	errorMessage:  {
		margin: '-35px auto 35px',
		opacity: 1,
		display: 'block',
		fontSize: '15px',
		lineHeight: '19px',
		fontFamily: 'Roboto, sans-serif',
		textAlign: 'center',
		fontWeight: 300,
		paddingTop: '7px',
		color: theme.palette.error.main,
		'& a': {
			color: theme.palette.primary.main
		}
	},
	/* loading icon */
	loadingWrapper: {
	},
	loadingMessage: {
		margin: '0 auto 35px',
		opacity: 1,
		display: 'block',
		fontSize: '15px',
		lineHeight: '19px',
		color: '#2A3F51',
		fontFamily: 'Roboto, sans-serif',
		textAlign: 'center',
		fontWeight: 300,
		paddingTop: '7px',
	},
	loadingIcon: {
		display: 'block',
		height: '24px',
		width: '24px',
		margin: '0 auto 10px',
		fill: '#0065f0',
		animation: 'spin 2s linear infinite'
	},
	'@keyframes spin': {
		'0': {
			transform: 'rotate(0deg)'
		},
		'100%': {
			transform: 'rotate(360deg)'
		}
	},
});

const AGENTS_NUMBER_DEFAULT = PACKAGES_CONFIG[SUBSCRIPTION_PLAN.BROKERAGES].freeSeatsIncluded;
const AGENTS_NUMBER_MAX = 140;// max slider value which renders to max 500

@withStyles(styles)
class RealEstatePackages extends Component {
	constructor(props) {
		super(props);

		this.agentsInputValue = React.createRef();

		this.state = {
			sliderValue: AGENTS_NUMBER_DEFAULT,

			sliderDragged: false,
			priceValue: '',
			priceSubtitleValue: '',
			focusPackage : '',
			agentsLegend: '',
			showSlider: true,
			showAddSeatsSection: false,
			initialQuantity: this.getInitialQuantity(),
			planIsTaxed: null,

			edit_mode_initial_slider_value: null,
			edit_mode_initial_input_value: null,
			edit_mode_modified_input_value: null,

			isEditMode: false,

			xhrInProgress: false,
			apiRequestError: false,
			apiRequestSuccess: false,
			errors: { apiError: null }			
		};

		this.handleSliderChangeDebounced = _.debounce(this.handleSliderChange, 350);
		this.handleWindowResizeDebounced = _.debounce(this.handleWindowResize.bind(this), 500);
		this.handleUpdateSeats = this.handleUpdateSeats.bind(this);
		this.switchToEditMode = this.switchToEditMode.bind(this);
		this.handleAgentsNumberClickAwayListener = this.handleAgentsNumberClickAwayListener.bind(this);
	}

	componentDidMount() {
		this.refreshAgentsNumberInSlider(this.getSliderQuantity(), false);
		this.preselectPackage();
		window.addEventListener('resize', this.handleWindowResizeDebounced);

		const viewPortWidth = document && window && Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
		if (viewPortWidth <= PACKAGES_HIDE_SIDEBAR_BREAKPOINT) {
			this.handleWindowResizeDebounced();
		}
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.handleWindowResizeDebounced);
	}

	componentWillReceiveProps(nextProps) {

		if (this.state.priceValue && this.props.symbol !== nextProps.symbol) {
			this.refreshAgentsNumberInSlider(this.state.renderedValue, false, nextProps.symbol);
		}

		if (this.props.companies.pendingPayingUserQuantity !== nextProps.companies.pendingPayingUserQuantity ||
			this.props.membersPaidQuantity !== nextProps.membersPaidQuantity ||
			this.props.totalNumberOfSeats !== nextProps.totalNumberOfSeats
		) {
			const initialQuantity = this.getInitialQuantity(nextProps.membersPaidQuantity);
			this.setState({
				initialQuantity
			}, () => {
				this.refreshAgentsNumberInSlider(nextProps.totalNumberOfSeats, false, nextProps.symbol);
			});		
		}

		if (
			(this.props.companies.createChargeBeeSubscriptionErrorId !== nextProps.companies.createChargeBeeSubscriptionErrorId &&
			nextProps.companies.createChargeBeeSubscriptionErrorId !== null)
			||
			(this.props.companies.purchaseSeatsErrorId !== nextProps.companies.purchaseSeatsErrorId &&
				nextProps.companies.purchaseSeatsErrorId !== null)
		) {
			this.handleApiErrors(nextProps);
		}

		if ((this.props.companies.createChargeBeeSubscriptionSuccess 
			!== nextProps.companies.createChargeBeeSubscriptionSuccess &&
			nextProps.companies.createChargeBeeSubscriptionSuccess === true)
				||
			(this.props.companies.purchaseSeatsSuccess 
				!== nextProps.companies.purchaseSeatsSuccess &&
				nextProps.companies.purchaseSeatsSuccess === true)
		) {
			this.setState({
				xhrInProgress: false,
				apiRequestError: false,
				apiRequestSuccess: Boolean(nextProps.companies.purchaseSeatsSuccess),
				errors: { apiError: null }
			});			
		}			

		/* eslint-disable max-len */ 
		const planEstimation = 
				_.get(this.props.companies,
					`subscriptionEstimation[${SUBSCRIPTION_PLAN.BROKERAGES}-${SUBSCRIPTION_PERIOD.MONTHLY}-${CB_API_FETCH_CURRENCY}].estimation`)
				||
				_.get(this.props.companies,
					`subscriptionEstimationActivePlan[${SUBSCRIPTION_PLAN.BROKERAGES}-${SUBSCRIPTION_PERIOD.MONTHLY}-${CB_API_FETCH_CURRENCY}].estimation`)
				||
				_.get(this.props.companies,
					`subscriptionEstimation[${SUBSCRIPTION_PLAN.INDIVIDUAL_AGENT}-${SUBSCRIPTION_PERIOD.MONTHLY}-${CB_API_FETCH_CURRENCY}].estimation`)
				||
				_.get(this.props.companies,
					`subscriptionEstimationActivePlan[${SUBSCRIPTION_PLAN.INDIVIDUAL_AGENT}-${SUBSCRIPTION_PERIOD.MONTHLY}-${CB_API_FETCH_CURRENCY}].estimation`);
		/* eslint-enable max-len */

		const isTaxed = _.get(planEstimation, 'isTaxed');
		if (isTaxed && !this.state.planIsTaxed) {
			this.setState({
				planIsTaxed: isTaxed
			},() => {
				this.refreshAgentsNumberInSlider(this.state.renderedValue, false, nextProps.symbol);
			});		
		}
	}

	handleApiErrors(nextProps) {
		if (nextProps.companies.createChargeBeeSubscriptionErrorId || nextProps.companies.purchaseSeatsErrorId) {
			const errorMessage = nextProps.companies.createChargeBeeSubscriptionErrorId &&
				errors[nextProps.companies.createChargeBeeSubscriptionErrorId] || 
				nextProps.companies.purchaseSeatsErrorId &&
				errors[nextProps.companies.purchaseSeatsErrorId] || 				
				localize('subscriptions-error-unknown');

			this.setState({
				xhrInProgress: false,
				apiRequestError: true,
				apiRequestSuccess: false,
				errors: { apiError: errorMessage }
			});
		}
	}	

	hasCancelledRePackage() {
		return [SUBSCRIPTION_PLAN.BROKERAGES, SUBSCRIPTION_PLAN.INDIVIDUAL_AGENT].includes(this.props.cancelledPlanId);
	}

	handleWindowResize() {
		// blue bar in slider does not update correctly when left side panel (menu) collapses during window resize
		// as there is no method on slider which would trigger resize, we have to toggle it for short period
		this.setState({
			showSlider: false
		},() => {
			setTimeout(() => {
				this.setState({
					showSlider: true
				},() => {
				});		
			}, 200);
		});		
	}	

	getInitialQuantity(nextMembersPaidQuantity) {
		if (this.props.currentPlanId) {
			if (this.props.currentPlanId === SUBSCRIPTION_PLAN.INDIVIDUAL_AGENT) {
				return 1;
			} else {
				return (nextMembersPaidQuantity || this.props.membersPaidQuantity) +
					PACKAGES_CONFIG[this.props.currentPlanId].freeSeatsIncluded;
			}
		} else {
			return this.props.quantity > 1 ? this.props.quantity : AGENTS_NUMBER_DEFAULT;
		}		
	}

	getSliderQuantity(nextPropsTotalNumberOfSeats) {
		let quantity = 0;
		const totalNumberOfSeats = nextPropsTotalNumberOfSeats || this.props.totalNumberOfSeats;

		if (!this.isIndividualAgentDisabled() && (this.props.realEstatePlan === SUBSCRIPTION_PLAN.INDIVIDUAL_AGENT ||
			this.props.currentPlanId === SUBSCRIPTION_PLAN.INDIVIDUAL_AGENT)) {
			quantity = this.props.quantity > 1 ? this.props.quantity : 1;
		} else {
			if (this.props.currentPlanId) {
				if (this.props.quantity != totalNumberOfSeats) {
					return this.props.membersPaidQuantity +
						PACKAGES_CONFIG[this.props.currentPlanId].freeSeatsIncluded +
						this.props.quantity;
				} else {
					quantity = totalNumberOfSeats > 1 ? totalNumberOfSeats : AGENTS_NUMBER_DEFAULT;
				}
			} else {
				quantity = this.props.quantity > 1 ? this.props.quantity : AGENTS_NUMBER_DEFAULT;
			}
		}

		return quantity;
	}

	handleSliderChange(renderedValue) {
		let newInputValue;

		if (this.props.currentPlanId) {
			if (this.props.currentPlanId === SUBSCRIPTION_PLAN.INDIVIDUAL_AGENT) {
				newInputValue = renderedValue === 1 ? 0 : renderedValue;	
			} else {
				newInputValue = renderedValue -
					this.props.membersPaidQuantity -
					PACKAGES_CONFIG[this.props.currentPlanId].freeSeatsIncluded;
			}
			
		} else {
			newInputValue = renderedValue === 1 ? 0 : renderedValue;	
		}

		this.props.setSeatsQuantity(newInputValue);

		setTimeout(() => {
			trackQuantityChange(
				'agent-seats',
				renderedValue,
				getTrackingOptions(this.props.company)
			);
		}, 250);
	}

	preselectPackage() {
		let preselectPackage;
		if (this.isIndividualAgentDisabled()) {
			preselectPackage = 'brokerages';
		} else if (this.props.realEstatePlan === SUBSCRIPTION_PLAN.INDIVIDUAL_AGENT) {
			preselectPackage = 'single-agent';
		} else if (this.props.realEstatePlan === SUBSCRIPTION_PLAN.BROKERAGES) {
			preselectPackage = 'brokerages';
		}

		preselectPackage && this.setState({ 
			preselectPackage
		});
	}

	calculatePricing(agentCount) {
		const basePrice = PACKAGES_CONFIG[SUBSCRIPTION_PLAN.BROKERAGES].basePrice;
		const includedAgents = PACKAGES_CONFIG[SUBSCRIPTION_PLAN.BROKERAGES].freeSeatsIncluded;
		const extraPricePerAgent = PACKAGES_CONFIG[SUBSCRIPTION_PLAN.BROKERAGES].extraPricePerAgent;

		const extraAgents = Math.max(agentCount - includedAgents, 0);
		const total = basePrice + (extraAgents * extraPricePerAgent);
		const perAgent = Math.round(total / agentCount);

		return { total, perAgent };
	}			

	renderFeaturesList(key, featuresList) {
		const { classes } = this.props;

		return (
			<List disablePadding className={classes.featuresList}>
				{featuresList.map((item, index) => (
					<ListItem key={`${key}-${index}`} dense className={classes.featuresListItem}>
						<ListItemIcon className={classes.featuresListIcon}>
							<CheckIconRounded />
						</ListItemIcon>
						<ListItemText
							className={classes.featuresListText}
						>
							<Typography
								variant='body2'
								className={classes.featuresListTitle}
							>
								{item.title}
							</Typography>
														
							{item.description && (
								<Typography
									variant='body2'
									className={classes.featuresListDescription}
								>
									{item.description}
								</Typography>
							)}
						</ListItemText>
					</ListItem>
				))}
			</List>
		);
	}

	getQuantitySnapValueForSliderValue(value) {
		let result;

		if (value === 1) {
			result = 1;

		} else if (value > 1 && value <= AGENTS_NUMBER_DEFAULT) {
			result = AGENTS_NUMBER_DEFAULT;

		} else if (value > AGENTS_NUMBER_DEFAULT && value <= 100) {
			result = value;

		} else if (value > 100 && value <= 105) {

			if (105 - value <= (105 - 100) / 2) {
				result = 150;
			} else {
				result = 100;
			}

		} else if (value > 105 && value <= 110) {

			if (110 - value <= (110 - 105) / 2) {
				result = 200;
			} else {
				result = 150;
			}

		} else if (value > 110 && value <= 115) {

			if (115 - value <= (115 - 110) / 2) {
				result = 250;
			} else {
				result = 200;
			}			

		} else if (value > 115 && value <= 120) {

			if (120 - value <= (120 - 115) / 2) {
				result = 300;
			} else {
				result = 250;
			}					

		} else if (value > 120) {
			if (140 - value <= (140 - 120) / 2) {
				result = 500;
			} else {
				result = 300;
			}		
		}

		return result;
	}

	snapRenderedValue(value) {
		let result;

		if (value < 0) {
			result = 1;

		} else if (value > 500) {
			result = 500;
			
		} else if (value <= 100) {
			result = value;

		} else if (value > 100 && value <= 150) {

			if (150 - value <= (150 - 100) / 2) {
				result = 150;
			} else {
				result = 100;
			}

		} else if (value > 150 && value <= 200) {

			if (200 - value <= (200 - 150) / 2) {
				result = 200;
			} else {
				result = 150;
			}

		} else if (value > 200 && value <= 250) {

			if (250 - value <= (250 - 200) / 2) {
				result = 250;
			} else {
				result = 200;
			}			

		} else if (value > 250 && value <= 300) {

			if (300 - value <= (300 - 250) / 2) {
				result = 300;
			} else {
				result = 250;
			}					

		} else if (value > 300) {
			if (500 - value <= (500 - 300) / 2) {
				result = 500;
			} else {
				result = 300;
			}		
		}

		return result;
	}

	getSliderSnapValueForQuantityValue(newInputValue) {
		// convert input range (1-500) to slider value (1-140) and snap it
		let sliderValue;

		if (newInputValue >= 1 && newInputValue <= 100) {
			sliderValue = newInputValue;

		} else if (newInputValue > 100 && newInputValue <= 150) {

			if (150 - newInputValue <= (150 - 100) / 2) {
				sliderValue = 105;
			} else {
				sliderValue = 100;
			}

		} else if (newInputValue > 150 && newInputValue <= 200) {

			if (200 - newInputValue <= (200 - 150) / 2) {
				sliderValue = 110;
			} else {
				sliderValue = 105;
			}

		} else if (newInputValue > 200 && newInputValue <= 250) {

			if (250 - newInputValue <= (250 - 200) / 2) {
				sliderValue = 115;
			} else {
				sliderValue = 110;
			}			

		} else if (newInputValue > 250 && newInputValue <= 300) {

			if (300 - newInputValue <= (300 - 250) / 2) {
				sliderValue = 120;
			} else {
				sliderValue = 115;
			}					

		} else if (newInputValue > 300) {
			if (500 - newInputValue <= (500 - 300) / 2) {
				sliderValue = 140;
			} else {
				sliderValue = 120;
			}		
		}

		return sliderValue;
	}	

	refreshAgentsNumberInSlider(quantityValue, refetchEstimationData, useSymbol, sliderValue) {

		if (FORCE_RE_CHECKOUT_WITH_ALL_USERS && !this.props.currentPlanId && quantityValue < this.props.nonGuestUsersNumber) {
			quantityValue = this.props.nonGuestUsersNumber;
		}

		let renderedValue = quantityValue > 1 && quantityValue < (AGENTS_NUMBER_DEFAULT+1) 
			?
			AGENTS_NUMBER_DEFAULT
			:
			quantityValue === 0 ? AGENTS_NUMBER_DEFAULT : quantityValue;

		// snap quantity from query param or input field
		renderedValue = this.snapRenderedValue(renderedValue);

		const { symbol } = this.props;
		let priceValue;
		let priceSubtitleValue;

		const vatLabel = this.props.getVatLabel(false, this.state.planIsTaxed, true);
		const valLabelValue = vatLabel ? ` ${vatLabel}` : '';

		if (renderedValue === 1) {
			priceValue = null;
			priceSubtitleValue = localize('re-packages-choose-team-size');

		} else if (renderedValue === AGENTS_NUMBER_DEFAULT ||
			renderedValue >= (AGENTS_NUMBER_DEFAULT+1) && renderedValue < 100) {

			const pricing = this.calculatePricing(renderedValue);

			priceValue =
				`${useSymbol || symbol}${pricing.total} <span>${localize('re-packages-per-month')}${valLabelValue}</span>`;

			priceSubtitleValue =
				`~${useSymbol || symbol}${pricing.perAgent} ${localize('re-packages-per-agent')}${valLabelValue}`;

		} else if (renderedValue >= 100) {
			priceValue = localize('re-packages-lets-talk');
			priceSubtitleValue = localize('re-packages-custom-pricing');
		}

		let focusPackage;
		if (renderedValue === 1) {
			focusPackage = 'single-agent';
		} else if (renderedValue >=(AGENTS_NUMBER_DEFAULT+1)) {
			focusPackage = 'brokerages';
		}

		let agentsLegend = '';
		if (renderedValue === 1) {
			agentsLegend = localize('re-packages-legend-agent', renderedValue);
		} else if (renderedValue > 1 && renderedValue <= AGENTS_NUMBER_DEFAULT) {
			agentsLegend = localize('re-packages-legend-up-to-agents', renderedValue);
		} else {
			agentsLegend = localize('re-packages-legend-agents', renderedValue);
			if (renderedValue === 500) {
				agentsLegend += '+';
			}
		}

		if (refetchEstimationData) {
			this.handleSliderChangeDebounced(renderedValue);
		}

		let newState = { 
			// slider state
			sliderValue: sliderValue || this.getSliderSnapValueForQuantityValue(quantityValue),
			renderedValue,
			priceValue,
			priceSubtitleValue,
			focusPackage,
			preselectPackage: null,
			agentsLegend,
			// on Esc key always reset slider to already snaped value
			edit_mode_initial_slider_value: this.getSliderSnapValueForQuantityValue(quantityValue),
			edit_mode_initial_input_value: renderedValue,
			edit_mode_modified_input_value: renderedValue
		};

		if (refetchEstimationData) {
			newState = {
				sliderDragged: true,
				...newState,

				// XHR state
				xhrInProgress: false,
				apiRequestError: false,
				apiRequestSuccess: false,
				errors: { apiError: null },
			};
		}

		if (this.isSliderDisabled() ||
			this.state.apiRequestSuccess && !_.get(newState, 'apiRequestSuccess') ||
			this.props.currentPlanId && this.state.initialQuantity !== renderedValue && renderedValue < 100) {
			newState.showAddSeatsSection = true;

		} else {
			newState.showAddSeatsSection = false;
		}
		this.setState(newState);
	}

	isSliderDisabled() {
		return Boolean(this.state.xhrInProgress || this.props.companies.pendingPayingUserQuantity);
	}

	isBrokerageSeatsDecrease() {
		return this.props.currentPlanId === SUBSCRIPTION_PLAN.BROKERAGES && 
			this.state.renderedValue < this.state.initialQuantity;
	}

	isBrokerageSeatsIncrease() {
		return this.props.currentPlanId === SUBSCRIPTION_PLAN.BROKERAGES &&
			this.state.renderedValue > this.state.initialQuantity;
	}

	handleUpdateSeats() {
		if (this.isBrokerageSeatsDecrease()) {
			const intercomMessage = localize(
				'package-brokerages-downgrade-seats-message',
				[this.state.initialQuantity, this.state.renderedValue, _.get(this.props.user, 'mainEmail')]
			);

			openIntercomChat(intercomMessage, true, this.props.showErrorPopup);
		} else {
			if (this.props.currentPlanId === SUBSCRIPTION_PLAN.INDIVIDUAL_AGENT) {

				const upgradeToPlan = SUBSCRIPTION_PLAN.BROKERAGES;

				const { freeSeatsIncluded } = PACKAGES_CONFIG[upgradeToPlan];

				let {
					checkoutPricePerMonth,
					annualPriceTotal,
					errorLoadingSubscriptionEstimationData,
					planIsTaxed
				} = this.props.calculateCheckoutData(
					upgradeToPlan,
					SUBSCRIPTION_PERIOD.MONTHLY,
					false /* isPerpetual */,
					this.props.quantity
				);

				this.props.handleBuyRequest(
					upgradeToPlan,
					SUBSCRIPTION_PERIOD.MONTHLY,
					Boolean(this.props.currentPlanId) /* isUpgrade */,
					false /*isPerpetual*/,
					PACKAGES_CONFIG[upgradeToPlan].title,
					false /* useDiscount*/,
					this.props.quantity,
					freeSeatsIncluded,
					checkoutPricePerMonth,
					annualPriceTotal,
					errorLoadingSubscriptionEstimationData,
					planIsTaxed
				);				
				
			} else {
				this.showPurchaseConfirmationPopup();
			}
		}
	}

	showPurchaseConfirmationPopup() {
		let message = `${localize('re-packages-add-more-seats-difference',
						[this.props.totalNumberOfSeats, 
							this.state.renderedValue,
						])}`;
		
		message+= `<br>${localize('subscription-extra-users-admin-member-usage')}`;
		message+= `<br>${localize('re-packages-add-more-seats-new-price', this.state.priceValue)}`;

		this.showConfirmationPopup(message)
			.then(() => this.makePurchase())
			.catch(() => {
				// silent catch - no error logged
			});
	}	

	/**
	 * Show purchase confirmation popup
	 *
	 * @param {string} message HTML message
	 * @returns Promise
	 */
	showConfirmationPopup(message) {
		return new Promise((resolve, reject) => {
			this.props.showModal('CONFIRMATION_MODAL', {
				title: localize('subscription-extra-users-title'),
				message: {
					__html: message
				},
				buttons: [
					<Button
						key='button-cancel'
						variant='outlined'
						color='primary'
						onClick={() => reject()}
					>
						{localize('cancel')}
					</Button>,
					<Button
						key='button-confirm'
						variant='contained'
						color='primary'
						onClick={() => resolve()}
					>
						{localize('pay-now')}
					</Button>
				]
			});
		});
	}

	makePurchase() {
		this.setState({
			xhrInProgress: true,
			apiRequestError: false,
			apiRequestSuccess: false,
			errors: { apiError: null }
		});

		this.props.buyMoreSeatsCallback();		
	}

	renderUpgradeNowButton(plan) {
		const { classes } = this.props;

		let label;
		let callback;
		let disabled = false;

		if (this.props.currentPlanId === SUBSCRIPTION_PLAN.BROKERAGES && plan === SUBSCRIPTION_PLAN.INDIVIDUAL_AGENT) {
			callback = () => {
				const intercomMessage = localize(
					'package-brokerages-downgrade-intercom-message', [_.get(this.props.user, 'mainEmail')]
				);

				openIntercomChat(intercomMessage, true, this.props.showErrorPopup);
			};

		} else if (plan === SUBSCRIPTION_PLAN.INDIVIDUAL_AGENT ||
			plan === SUBSCRIPTION_PLAN.BROKERAGES && this.state.renderedValue < 100) {

			const { freeSeatsIncluded } = PACKAGES_CONFIG[plan];

			callback = () => {
				let {
					checkoutPricePerMonth,
					annualPriceTotal,
					errorLoadingSubscriptionEstimationData,
					planIsTaxed
				} = this.props.calculateCheckoutData(
					plan,
					SUBSCRIPTION_PERIOD.MONTHLY,
					false /* isPerpetual */,
					this.props.quantity
				);

				this.props.handleBuyRequest(
					plan,
					SUBSCRIPTION_PERIOD.MONTHLY,
					Boolean(this.props.currentPlanId) /* isUpgrade */,
					false /*isPerpetual*/,
					PACKAGES_CONFIG[plan].title,
					false /* useDiscount*/,
					this.props.quantity,
					freeSeatsIncluded,
					checkoutPricePerMonth,
					annualPriceTotal,
					errorLoadingSubscriptionEstimationData,
					planIsTaxed
				);
			};
		}

		if (plan === SUBSCRIPTION_PLAN.INDIVIDUAL_AGENT) {
			disabled = this.props.companies.getSubscriptionEstimateXhrInProgress ||
				this.props.currentPlanId === SUBSCRIPTION_PLAN.INDIVIDUAL_AGENT ||
				this.isIndividualAgentDisabled();

			if (this.isIndividualAgentDisabled()) {
				label = localize('re-packages-plan-disabled');
			} else if (this.props.cancelledPlanId === SUBSCRIPTION_PLAN.INDIVIDUAL_AGENT) {
				label = localize('re-packages-reactivate-plan');
			} else if (this.props.currentPlanId === SUBSCRIPTION_PLAN.INDIVIDUAL_AGENT) {
				label = localize('subscription-plan-tag-current-plan');
			} else if (this.props.currentPlanId === SUBSCRIPTION_PLAN.BROKERAGES) {
				label = localize('subscription-action-downgrade-to-individual-agent');
			} else {
				label = localize('subscription-action-upgrade-now');
			}
				
		} else if (plan === SUBSCRIPTION_PLAN.BROKERAGES) {

			disabled = this.props.companies.getSubscriptionEstimateXhrInProgress && this.state.renderedValue < 100;

			if (this.state.renderedValue >= 100) {
				label = localize('subscription-action-talk-to-sales');

			} else if (this.props.cancelledPlanId === SUBSCRIPTION_PLAN.BROKERAGES) {
				label = localize('re-packages-reactivate-plan');

			} else if (this.props.currentPlanId === SUBSCRIPTION_PLAN.BROKERAGES) {
				label = localize('subscription-plan-tag-current-plan');
				disabled = true;
				
			} else {
				label = localize('subscription-action-upgrade-now');
			}

			if (this.state.renderedValue >= 100) {
				const agentsNumber = parseInt(this.state.renderedValue) >= 500 ? '500+' : this.state.renderedValue;
				const intercomMessage = localize(
					'package-brokerages-upgrade-intercom-message',
					[agentsNumber, _.get(this.props.user, 'mainEmail')]
				);
				
				callback = () => {
					openIntercomChat(intercomMessage, true, this.props.showErrorPopup);
				};
			}
		}

		return (
			<div className={classes.purchaseButtonContainer}>
				<Button
					variant={plan === SUBSCRIPTION_PLAN.BROKERAGES ? 'contained' : 'outlined'}
					data-tid={`button-subscription-update-${plan}`}
					key={`button-subscription-update-${plan}`}
					disabled={disabled}
					className={
						classNames({
							[classes.button]: true,
							['disabled']: disabled,
							['updating']: this.props.companies.getSubscriptionEstimateXhrInProgress,
							[plan === SUBSCRIPTION_PLAN.BROKERAGES
								? classes.purchaseButtonContained
								:
								classes.purchaseButtonOutlined]: true
						})
					}

					onClick={callback}
				>
					{label}
				</Button>
			</div>
		);
	}

	isIndividualAgentDisabled() {
		return this.props.nonGuestUsersNumber > 1 && !this.props.currentPlanId;
	}

	renderStatusAndLinks() {
		const { classes } = this.props;

		let subscriptionStatus;
		let statusClass;

		if (this.props.pendingCancellationDate) {
			subscriptionStatus = localize('re-packages-status-pending-cancellation');
			statusClass = classes.statusCancelled;
		} else if (this.props.nextBillingDate) {
			subscriptionStatus = localize('re-packages-status-active');
			statusClass = classes.statusActive;
		} else if (this.hasCancelledRePackage()) {
			subscriptionStatus = localize('re-packages-status-cancelled');
			statusClass = classes.statusCancelled;
		}

		return (<Grid
			item
			container
			className={classes.statusAndLinksGrid}
		>
			<Grid item className={classes.statusGrid}>
				{
					this.props.nextBillingDate &&
					(
						<Typography
							variant='body2'
							className={classes.nextBilling}
						>
							<strong>{localize('re-packages-next-billing')}</strong>: {this.props.nextBillingDate}
						</Typography>				
					)
				}
				{
					(this.hasCancelledRePackage() || this.props.pendingCancellationDate) &&
					(
						<Typography
							variant='body2'
							className={classNames(
								classes.status,
								statusClass
							)}					
						>
							<strong>{localize('re-packages-status')}</strong>: {subscriptionStatus}
						</Typography>				
					)
				}
			</Grid>
			<Grid item className={classes.linksGrid}>
				<List className={classes.manageCBList}>
					<ListItem className={classes.manageCBListItem}>
						<Link
							component="button"
							variant="body2"
							data-tid='re-packages-manage-payment-method'
							className={classes.manageCBLink}
							onClick={() => this.props.showSubscriptionDetails()}
						>
							{localize('re-packages-manage-payment-method')}
						</Link>
					</ListItem>
					<ListItem className={classes.manageCBListItem}>
						<Link
							component="button"
							variant="body2"
							data-tid='re-packages-view-invoices'
							className={classes.manageCBLink}
							onClick={() => this.props.showSubscriptionDetails()}
						>
							{localize('re-packages-view-invoices')}
						</Link>
					</ListItem>
					<ListItem className={classes.manageCBListItem}>
						{this.renderCancelOrReactivateLink()}
					</ListItem>
				</List>
			</Grid>					
		</Grid>);
	}

	renderCancelOrReactivateLink() {
		const { classes } = this.props;

		if (this.props.pendingCancellationDate) {
			return (
				<Link
					component="button"
					variant="body2"
					data-tid='re-packages-cancel-plan'
					className={classes.manageCBLink}
					onClick={() => this.props.showSubscriptionDetails()}
				>
					{localize('re-packages-revoke-cancellation')}
				</Link>
			);
		} else if (this.props.currentPlanId) {
			return (
				<Link
					component="button"
					variant="body2"
					data-tid='re-packages-cancel-plan'
					className={classes.manageCBLink}
					onClick={() => this.props.showSubscriptionDetails()}
				>
					{localize('re-packages-cancel-plan')}
				</Link>
			);
		} else if (this.hasCancelledRePackage()) {
			return (
				<Link
					component="button"
					variant="body2"
					data-tid='re-packages-cancel-plan'
					className={classes.manageCBLink}
					onClick={() => this.props.reactivateMySubscriptionHandler(this.props.cancelledSubscription)}
				>
					{localize('re-packages-reactivate-plan')}
				</Link>
			);
		}
	}

	switchToEditMode() {
		this.setState({
			edit_mode_initial_slider_value: this.state.sliderValue,
			edit_mode_initial_input_value: this.state.renderedValue,
			edit_mode_modified_input_value: this.state.renderedValue,
			isEditMode: true
		});	

		setTimeout(function () {
			this.agentsInputValue.current && this.agentsInputValue.current.focus();
		}.bind(this), 100);
	}

	handleAgentsNumberClickAwayListener() {
		this.updateSliderFromInput();
	}

	onAgentsNumberChange(event) {
		this.setState({
			edit_mode_modified_input_value: event.target.value
		});			
	}

	updateSliderFromInput() {
		// On Enter or blur: commit the value and update the slider thumb position.
		const parsedInputValue = parseInt(this.agentsInputValue.current.value);

		// Only integers
		const newInputValue = isNaN(parsedInputValue) ? 1 : parsedInputValue;

		this.refreshAgentsNumberInSlider(newInputValue, true);
	}

	onAgentsNumberKeyDown(event) {
		if (event.key === 'Escape' || event.keyCode === 27) { // escape
			// On Escape: cancel and revert to the previous value.
			event.preventDefault();

			this.setState({
				edit_mode_modified_input_value: this.state.edit_mode_initial_slider_value
			}, () => {
				this.refreshAgentsNumberInSlider(this.state.edit_mode_initial_input_value, true);
				this.agentsInputValue.current && this.agentsInputValue.current.blur();
			});				
			

		} else if (event.key === 'Enter' || event.keyCode === 13) { // enter
			event.preventDefault();
			this.updateSliderFromInput();
		}		
	}	

	render() {

		const { sliderValue } = this.state;
		const { classes, symbol } = this.props;

		const individualAgentPrice = PACKAGES_CONFIG[SUBSCRIPTION_PLAN.INDIVIDUAL_AGENT].basePrice;

		const vatLabel = this.props.getVatLabel(false, this.state.planIsTaxed, true);
		const valLabelValue = vatLabel ? ` ${vatLabel}` : '';
		const individualAgentPriceString =
			`${symbol}${individualAgentPrice} <span>${localize('re-packages-per-month')}${valLabelValue}</span>`;

		const sliderDisabled = this.isSliderDisabled();

		const renderAgentsQuantityField = () => {
			return (
				<ClickAwayListener onClickAway={this.handleAgentsNumberClickAwayListener}>
					<FormField
						value={this.state.edit_mode_modified_input_value}
						className={classes.agentsQuantityField}
						data-tid="agents-quantity-field"
						onChange={event => this.onAgentsNumberChange(event)}
						onKeyDown={event => this.onAgentsNumberKeyDown(event)}
						id="agents-quantity-field"
						type="text"
						autoComplete='off'
						margin="normal"
						inputRef={this.agentsInputValue}
					/>
				</ClickAwayListener>
			);
		};

		const renderPendingCancellationDate = () => (
			<Typography
				variant='body2'
				className={classes.packageEndsOn}							
			>
				<Tooltip
					placement="bottom"
					title={
						<React.Fragment>
							<Typography variant='body2' className={classNames(classes.infoTooltipText)}>
								{localize('subscription-undo-cancellation-info-real-estate')}
							</Typography>					
							<span className={classes.tooltipArrow} />
						</React.Fragment>
					}
					classes={{
						tooltip: classes.infoTooltip
					}}
				>
					<IconButton
						className={classes.infoIconButton}
						color='primary'
						component='span'
						disableRipple
					>
						<Info />
					</IconButton>
				</Tooltip>

				{localize('re-packages-ends-on')} {this.props.pendingCancellationDate}
			</Typography>
		);

		const renderCancelledInfo = () => (
			<Typography
				variant='body2'
				className={classes.packageEndsOn}							
			>
				<Tooltip
					placement="bottom"
					title={
						<React.Fragment>
							<Typography variant='body2' className={classNames(classes.infoTooltipText)}>
								{localize('subscription-reactivate-plan-info-real-estate')}
							</Typography>					
							<span className={classes.tooltipArrow} />
						</React.Fragment>
					}
					classes={{
						tooltip: classes.infoTooltip
					}}
				>
					<IconButton
						className={classes.infoIconButton}
						color='primary'
						component='span'
						disableRipple
					>
						<Info />
					</IconButton>
				</Tooltip>

				{localize('re-packages-status-cancelled')}
			</Typography>
		);		

		const renderLoading = () => {
			const { classes } = this.props;
			return (
				<div className={classes.loadingWrapper}>
					<SpinnerIcon className={classes.loadingIcon} />
					<Typography className={classes.loadingMessage} variant="body2">
						{localize('subscriptions-modal-fetching-data')}
					</Typography>
				</div>
			);
		};

		const renderSuccessMessage = () => {
			const { classes } = this.props;
			return (
				<Grid 
					className={classes.successMessagesGrid}
					item
					container
				>
					<Typography className={classes.successMessage} variant="body2">
						{localize('re-packages-success-purchasing-seats')}
					</Typography>
				</Grid>			
			);
		};

		const renderErrorMessage = () => {
			const errorMessage = _.get(this.state, 'errors.apiError');
			const { classes } = this.props;

			return (
				<Grid 
					className={classes.errorMessagesGrid}
					item
					container
				>
					<Typography 
						className={classes.errorMessage} 
						variant="body2" 
						dangerouslySetInnerHTML={{ __html: errorMessage }} />
				</Grid>			
			);
		};

		const renderAddSeatsButton = () => (
			<React.Fragment>
				<Grid 
					className={classes.addMoreSeatsWrapper}
					item
					container
				>
					<Grid item className={classes.addMoreSeatsGrid}>
						<Button
							variant='contained'
							data-tid='button-subscription-seats'
							key='button-subscription-seats'
							className={
								classNames({
									[classes.button]: true,
									[classes.updateSeatsButton] : true
								})
							}
							onClick={this.handleUpdateSeats}
						>
							<UpdateSeatsIcon className={classes.updateSeatsButtonIcon} />
							{localize('subscription-action-update-seats')}
						</Button>
					</Grid>
					<Grid item className={classes.addMoreSeatsGrid}>
						<Typography
							variant='body2'
							className={classes.addMoreSeatsMesssage}
							dangerouslySetInnerHTML={{ __html: 
								localize(
									're-packages-add-more-seats',
									[
										this.state.renderedValue, 
										this.state.renderedValue > 1
											?
											this.state.priceValue
											:
											individualAgentPriceString
									]
								)
							}} 
						/>
					</Grid>
				</Grid>	
				{Object.keys(this.state.errors).length > 0 && renderErrorMessage()}
			</React.Fragment>
		);

		const renderAddSeatsSection = () => {
			if (this.state.xhrInProgress || this.props.companies.pendingPayingUserQuantity) {
				return renderLoading();
			} else if (this.state.apiRequestSuccess) {
				return renderSuccessMessage();
				
			} else if (this.state.apiRequestError) {
				return renderAddSeatsButton();
			} else {
				return renderAddSeatsButton();
			}
		};

		return (
			<div className={classes.realEstateUiWrapper}>
				<Grid
					item
					container
					className={classes.sliderHeader}
				>
					<Typography 
						variant='body2'
						className={classes.sliderTitle}
					>
						{localize('re-packages-slider-title')}
					</Typography>							
					<Typography
						variant='body2'
						className={classes.sliderSubtitle}
					>
						{localize('re-packages-slider-subtitle')}
					</Typography>							
				</Grid>				
				<Grid 
					item
					container 
					className={
						classNames({
							[classes.sliderWrapper]: true,
							['hasCurrency']: this.props.shouldRenderCurrencySelector,
							['reducedMargin']: this.state.showAddSeatsSection
						})
					}>

					<Grid
						item 
						className={
							classNames({
								[classes.sliderGrid]: true,
								['hasCurrency']: this.props.shouldRenderCurrencySelector
							})
						}>
						{this.state.showSlider && (
							<ReactSlider
								withBars={true}
								disabled={sliderDisabled}
								className={
									classNames({
										[classes.slider]: true,
										['disabled']: sliderDisabled,
										['reducedMargin']: this.state.showAddSeatsSection
									})								
								}
								handleClassName={classes.handle}
								value={sliderValue}
								defaultValue={AGENTS_NUMBER_DEFAULT}
								min={1}
								max={AGENTS_NUMBER_MAX}
								step={1}
								onChange={(value) =>
									this.refreshAgentsNumberInSlider(
										this.getQuantitySnapValueForSliderValue(value), true, null, value)
								}
								onAfterChange={(value) => {
									// snap handle on release if slider value is not matching snaped slider value
									const sliderRangeForInputValue = 
										this.getSliderSnapValueForQuantityValue(this.state.renderedValue);

									if (value !== sliderRangeForInputValue) {
										this.refreshAgentsNumberInSlider(this.state.renderedValue, true);
									}
								}}
							>
							</ReactSlider>							
						)}
					</Grid>
					<Grid item className={classes.sliderValueWrapper}>
						<Typography
							variant='body2'
							className={classes.agentsLegendLabel}
						>
							{localize('re-packages-legend-label')}: 

							{
								this.state.isEditMode
									?
									renderAgentsQuantityField()
									:
									(
										<span
											className={classes.agentsLegendValue}
											onClick={this.switchToEditMode}
										>
											{this.state.agentsLegend}
										</span>									
									)
							}
						</Typography>
						{
							this.state.isEditMode ?
								(
									<Typography
										variant='body2'
										className={
											classNames({
												[classes.quantityNumberInfo]: true,
												[classes.quantityNumberInfoSave]: true,
											})
										}							
									>
										{localize('re-packages-legend-save-info')}
									</Typography>
								)							
								:
								(
									<Typography
										variant='body2'
										className={
											classNames({
												[classes.quantityNumberInfo]: true,
												[classes.quantityNumberInfoClickToEdit]: true,
											})
										}							
									>
										{localize('re-packages-legend-click-info')}
									</Typography>
								)							
						}
						
					</Grid>
					{
						this.props.shouldRenderCurrencySelector && (
							<Grid item className={classes.currencySelectorGrid}>
								{this.props.renderCurrencySelector()}
							</Grid>							
						)
					}
				</Grid>
				{this.state.showAddSeatsSection && renderAddSeatsSection()}
				<Grid
					item
					container
					className={
						classNames({
							[classes.packagesContainerWrapper]: true,

							[classes.singleAgentCardActive]:  !this.isIndividualAgentDisabled() && 
								(this.state.preselectPackage === 'single-agent' ||
								this.state.focusPackage === 'single-agent' && this.state.sliderDragged),

							[classes.brokeragesCardActive]: this.isIndividualAgentDisabled() ||
								(this.state.preselectPackage === 'brokerages' ||
								this.state.focusPackage === 'brokerages' && this.state.sliderDragged),

							[classes.brokeragesCurrentPlan]:
								this.props.currentPlanId === SUBSCRIPTION_PLAN.BROKERAGES &&
								!this.props.pendingCancellationDate,

							[classes.singleAgentCurrentPlan]:
								this.props.currentPlanId === SUBSCRIPTION_PLAN.INDIVIDUAL_AGENT &&
								!this.props.pendingCancellationDate,

							[classes.brokeragesPlanPendingCancellation]: 
								this.props.currentPlanId === SUBSCRIPTION_PLAN.BROKERAGES && this.props.pendingCancellationDate,
							
							[classes.singleAgentPlanPendingCancellation]:
								this.props.currentPlanId === SUBSCRIPTION_PLAN.INDIVIDUAL_AGENT &&
								this.props.pendingCancellationDate,

							[classes.brokeragesPlanCancelled]: this.props.cancelledPlanId === SUBSCRIPTION_PLAN.BROKERAGES,
							
							[classes.singleAgentPlanCancelled]: this.props.cancelledPlanId === SUBSCRIPTION_PLAN.INDIVIDUAL_AGENT,

							[classes.brokerageDecreasingSeats]: this.isBrokerageSeatsDecrease() && this.state.renderedValue > 1,
							[classes.brokerageIncreasingSeats]: this.isBrokerageSeatsIncrease() && this.state.renderedValue > 1 &&
							!(this.props.currentPlanId === SUBSCRIPTION_PLAN.BROKERAGES && this.props.pendingCancellationDate),

							[classes.singleAgentPlanDisabled]: this.isIndividualAgentDisabled(),
						})
					}
				>
					<Grid
						item
						className={
							classNames({
								[classes.individualAgentsPackage]: true,
								['individualAgentsPackage']: true,
								[classes.package]: true,
							})
						}					
					>
						<Typography
							variant='body2'
							className={
								classNames({
									['packageTag']: true,
									[classes.packageTag]: true,
								})
							}							
						>
							{
								this.props.currentPlanId === SUBSCRIPTION_PLAN.INDIVIDUAL_AGENT
									?
									localize('subscription-plan-tag-current-plan')
									:
									PACKAGES_CONFIG[SUBSCRIPTION_PLAN.INDIVIDUAL_AGENT].tag
							}
						</Typography>						
						{this.props.currentPlanId === SUBSCRIPTION_PLAN.INDIVIDUAL_AGENT &&
							this.props.pendingCancellationDate && renderPendingCancellationDate()}
						{this.props.cancelledPlanId === SUBSCRIPTION_PLAN.INDIVIDUAL_AGENT && renderCancelledInfo()}
						<Typography
							variant='h2'
							className={classes.packageTitle}
						>
							{PACKAGES_CONFIG[SUBSCRIPTION_PLAN.INDIVIDUAL_AGENT].title}
						</Typography>
						<Typography
							variant='body2'
							className={
								classNames({
									['packagePrice']: true,
									[classes.packagePrice]: true,
								})
							}
							dangerouslySetInnerHTML={{ __html: 
								`${symbol}${individualAgentPrice} <span>${localize('re-packages-per-month')}</span>`
							}} />

						<Typography
							variant='body2'
							className={classes.packageSubtitle}
						>
							{PACKAGES_CONFIG[SUBSCRIPTION_PLAN.INDIVIDUAL_AGENT].subtitle}
						</Typography>

						{this.renderFeaturesList('individual-agents-features',
							PACKAGES_CONFIG[SUBSCRIPTION_PLAN.INDIVIDUAL_AGENT].individualAgentsFeatureslist)}

						<Typography
							variant='h3'
							className={classes.featuresGroupTitle}
						>
							{PACKAGES_CONFIG[SUBSCRIPTION_PLAN.INDIVIDUAL_AGENT].whatYouGetTitle}
						</Typography>

						{this.renderFeaturesList('individual-agents-what-you-get',
							PACKAGES_CONFIG[SUBSCRIPTION_PLAN.INDIVIDUAL_AGENT].individualAgentsWhatToGet)}
						
						{this.renderUpgradeNowButton(SUBSCRIPTION_PLAN.INDIVIDUAL_AGENT)}

					</Grid>
					<Grid
						item
						className={
							classNames({
								[classes.brokeragesPackage]: true,
								['brokeragesPackage']: true,
								[classes.package]: true,
							})
						}					
					>
						<Typography
							variant='body2'
							className={
								classNames({
									['packageTag']: true,
									[classes.packageTag]: true,
								})
							}							
						>
							{
								this.props.currentPlanId === SUBSCRIPTION_PLAN.BROKERAGES
									?
									localize('subscription-plan-tag-current-plan')
									:
									PACKAGES_CONFIG[SUBSCRIPTION_PLAN.BROKERAGES].tag
							}							
						</Typography>						
						{this.props.currentPlanId === SUBSCRIPTION_PLAN.BROKERAGES &&
							this.props.pendingCancellationDate && renderPendingCancellationDate()}
						{this.props.cancelledPlanId === SUBSCRIPTION_PLAN.BROKERAGES && renderCancelledInfo()}
						<Typography
							variant='h2'
							className={
								classNames({
									['packageTitle']: true,
									[classes.packageTitle]: true,
								})
							}								
						>
							{PACKAGES_CONFIG[SUBSCRIPTION_PLAN.BROKERAGES].title}
						</Typography>
						{
							this.state.priceValue && (
								<Typography
									variant='body2'
									className={
										classNames({
											['packagePrice']: true,
											[classes.packagePrice]: true,
										})
									}
									dangerouslySetInnerHTML={{ __html: this.state.priceValue }} />
							)
						}
						{
							this.state.priceSubtitleValue && (
								<Typography
									variant='body2'
									className={
										classNames({
											['packageSubtitle']: true,
											[classes.packageSubtitle]: true,
										})
									}										
									dangerouslySetInnerHTML={{ __html: this.state.priceSubtitleValue}} />			
							)
						}

						<div className={classes.sectionsList}>
							{PACKAGES_CONFIG[SUBSCRIPTION_PLAN.BROKERAGES].brokeragesFeatureslist &&
							PACKAGES_CONFIG[SUBSCRIPTION_PLAN.BROKERAGES].brokeragesFeatureslist.map((item, index) => (
								<ExpansionPanel key={`brokerages-feature-section-${index}`}>
									<ExpansionPanelSummary expandIcon={<ExpandMoreIcon className={classes.sectionsListIcon} />}>
										<div className={classes.sectionsListText}>
											<Typography
												variant='h3'
												className={classes.sectionsListTitle}
											>
												{item.title}
											</Typography>

											{item.description && (
												<Typography
													variant='body2'
													className={classes.sectionsListDescription}
												>
													{item.description}
												</Typography>
											)}
										</div>
									</ExpansionPanelSummary>
									<ExpansionPanelDetails>
										{this.renderFeaturesList('brokerages-features', item.featuresList)}
									</ExpansionPanelDetails>
								</ExpansionPanel>		
							))}
						</div>

						{this.renderUpgradeNowButton(SUBSCRIPTION_PLAN.BROKERAGES)}

					</Grid>
				</Grid>
				{(this.props.currentPlanId ||
						this.props.pendingCancellationDate ||
						this.props.cancelledPlanId) && this.renderStatusAndLinks()}
			</div>
		);
	}
}

RealEstatePackages.propTypes = {
	showErrorPopup: PropTypes.func.isRequired,
	classes: PropTypes.object,
	symbol: PropTypes.string,
	renderCurrencySelector: PropTypes.func,
	user: PropTypes.object.isRequired,
	handleBuyRequest: PropTypes.func,
	calculateCheckoutData: PropTypes.func,
	fetchSubscriptionEstimate: PropTypes.func,
	realEstatePlan: PropTypes.func,
	setSeatsQuantity: PropTypes.func,
	quantity: PropTypes.number,
	company: PropTypes.object,
	companies: PropTypes.object,
	currentPlanId: PropTypes.string,
	showSubscriptionDetails: PropTypes.func,
	reactivateMySubscriptionHandler: PropTypes.func,
	buyMoreSeatsCallback: PropTypes.func,
	nextBillingDate: PropTypes.string,
	pendingCancellationDate: PropTypes.string,
	cancelledPlanId: PropTypes.string,
	cancelledSubscription: PropTypes.object,
	totalNumberOfSeats: PropTypes.number,
	getVatLabel: PropTypes.func,
	nonGuestUsersNumber: PropTypes.number,
	membersPaidQuantity: PropTypes.number,
	showModal: PropTypes.func,
	shouldRenderCurrencySelector: PropTypes.bool,
};

const mapStateToProps = state => ({
	user: state.session.user,
	company: state.companies.rawDataById[state.companies.selectedId],
	companies: state.companies,
});

const mapDispatchToProps = dispatch => bindActionCreators({
	setSeatsQuantity,
	showModal
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(RealEstatePackages);


// WEBPACK FOOTER //
// ./src/components/RealEstatePackages/index.js